import FooterSelectedNumber from './FooterSelectedNumber';

export default FooterSelectedNumber;
